import { createFileRoute } from "@tanstack/react-router"

import { createTeamBoardPageStore } from "@/lib/stores/team-board-page-store"

export const Route = createFileRoute("/_authed/_admin/guild-war/team-board")({
  beforeLoad: () => ({
    teamBoardStore: createTeamBoardPageStore(),
  }),
})
